import { ProjectOption } from '../../hooks/useProjectSelect';
import styles from './ProjectSelect.module.css';
import { FormatOptionLabelMeta, mergeStyles, NamedProps, StylesConfig } from 'react-select';
import { Select } from '@round/whitelabel-ui';
import { Image } from '@round/ui-kit';

export const ProjectOptionLabel = ({ option }: { option: ProjectOption }) => {
    return (
        <div className={styles.container}>
            <Image className={styles.image} src={option.brand?.image ?? ''} alt={option.brand?.name ?? ''} />
            <div className={styles.details}>
                <p>{option.label}</p>
                <p className={styles.subValue}>{`${option.brand?.name} - ${option.team?.name}`}</p>
            </div>
        </div>
    );
};

export const getDefaultProjectOptionLabel = (
    option: ProjectOption,
    meta: FormatOptionLabelMeta<ProjectOption, false>
) => {
    if (meta.context === 'value') {
        return option.label;
    }

    return <ProjectOptionLabel option={option} />;
};

const selectStyles: StylesConfig = {
    menu: (base) => ({
        ...base,
        minWidth: 'min(24rem, 100vw)',
    }),
};

const ProjectSelect = (props: NamedProps<ProjectOption>) => {
    const mergedStyles = props.styles ? mergeStyles(props.styles, selectStyles) : selectStyles;
    return (
        <Select
            {...props}
            formatOptionLabel={props.formatOptionLabel || getDefaultProjectOptionLabel}
            styles={mergedStyles}
            placeholder={props.placeholder || 'Select project...'}
        />
    );
};

export default ProjectSelect;
